import apiService from '../utils/apiService';

import {
  ADD_SUBMISSION_DATA_SIGNET_DESTROYED,
  ADD_SUBMISSION_DATA_SIGNET_DESTROYED_START,
  ADD_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_START,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_START,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_ERROR,
  GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_START,
  REMOVE_SUBMISSION_DATA_SIGNET_DESTROYED,
} from './types';

import {
  submissionDataSignetDestroyedUploadPath,
  submissionDataSignetDestroyedFindBySubmissionDataSignetPath,
  submissionDataSignetDestroyedFindByNamePath,
  submissionDataSignetDestroyedFindAllBySubmissionDataSignetIdPath,
} from '../constants/apiEndpoints';

import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';
import { createNotification } from '../utils';

const unmountAttachment = () => {
  return {
    type: REMOVE_SUBMISSION_DATA_SIGNET_DESTROYED,
  };
};

const addSubmissionDataSignetDestroyedStart = () => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_DESTROYED_START,
  };
};
const addSubmissionDataSignetDestroyedSuccessfully = (data) => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_DESTROYED,
    payload: data,
  };
};
const addSubmissionDataSignetDestroyedUnsuccessfully = (err) => {
  return {
    type: ADD_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR,
    payload: err,
  };
};

const getSubmissionDataSignetDestroyedStart = () => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_START,
  };
};
const getSubmissionDataSignetDestroyedSuccessfully = (data) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED,
    payload: data,
  };
};
const getSubmissionDataSignetDestroyedUnsuccessfully = (err) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_ERROR,
    payload: err,
  };
};

const getSubmissionDataSignetDestroyedContentForPreviewStart = () => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_START,
  };
};
const getSubmissionDataSignetDestroyedContentForPreviewSuccessfully = (
  data
) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW,
    payload: data,
  };
};
const getSubmissionDataSignetDestroyedContentForPreviewUnsuccessfully = (
  err
) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_CONTENT_FOR_PREVIEW_ERROR,
    payload: err,
  };
};

const getSubmissionDataSignetDestroyedListStart = () => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_START,
  };
};
const getSubmissionDataSignetDestroyedListSuccessfully = (data) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST,
    payload: data,
  };
};
const getSubmissionDataSignetDestroyedListUnsuccessfully = (err) => {
  return {
    type: GET_SUBMISSION_DATA_SIGNET_DESTROYED_LIST_ERROR,
    payload: err,
  };
};

export const uploadSubmissionDataSignetDestroyed = (
  fileData,
  submissionDataSignetId,
  callback,
  NotificationMessages
) => {
  return (dispatch) => {
    dispatch(addSubmissionDataSignetDestroyedStart());
    return apiService
      .post(
        submissionDataSignetDestroyedUploadPath(submissionDataSignetId),
        fileData
      )
      .then((response) => {
        dispatch(addSubmissionDataSignetDestroyedSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          NotificationMessages.uploadSignetDestroyed,
          NotificationMessages.successSignetDestroyedUpload
        );
      })
      .catch((err) => {
        dispatch(
          addSubmissionDataSignetDestroyedUnsuccessfully(err?.response?.data)
        );
        createNotification(
          notificationTypeError,
          NotificationMessages.uploadSignetDestroyed,
          err?.response?.data?.message
        );
      });
  };
};

export const findSubmissionDataSignetDestroyedLatestVersione = (
  submissionDataSignetId
) => {
  return (dispatch) => {
    dispatch(getSubmissionDataSignetDestroyedStart());
    return apiService
      .get(
        submissionDataSignetDestroyedFindBySubmissionDataSignetPath(
          submissionDataSignetId
        )
      )
      .then((response) => {
        dispatch(getSubmissionDataSignetDestroyedSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getSubmissionDataSignetDestroyedUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const findSubmissionDataSignetDestroyedByName = (
  name,
  controllerReference
) => {
  return (dispatch) => {
    dispatch(getSubmissionDataSignetDestroyedContentForPreviewStart());
    return apiService
      .get(
        submissionDataSignetDestroyedFindByNamePath(name, controllerReference)
      )
      .then((response) => {
        dispatch(
          getSubmissionDataSignetDestroyedContentForPreviewSuccessfully(
            response.data
          )
        );
      })
      .catch((err) => {
        dispatch(
          getSubmissionDataSignetDestroyedContentForPreviewUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const findAllSubmissionDataSignetDestroyedBySubmissionDataSignetId = (
  submissionDataSignetDestroyedId
) => {
  return (dispatch) => {
    dispatch(getSubmissionDataSignetDestroyedListStart());
    return apiService
      .get(
        submissionDataSignetDestroyedFindAllBySubmissionDataSignetIdPath(
          submissionDataSignetDestroyedId
        )
      )
      .then((response) => {
        dispatch(
          getSubmissionDataSignetDestroyedListSuccessfully(response.data)
        );
      })
      .catch((err) => {
        dispatch(
          getSubmissionDataSignetDestroyedListUnsuccessfully(
            err?.response?.data
          )
        );
      });
  };
};

export const deleteDestroyedContetnt = () => {
  return (dispatch) => {
    dispatch(unmountAttachment());
  };
};
